import React, { useState } from 'react';

interface SafeImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    fallback?: React.ReactNode;
}

/**
 * A resilient image component that handles loading errors gracefully.
 * If the image fails to load (e.g. CORS error, 404), it can show a fallback or hide itself.
 */
export const SafeImage: React.FC<SafeImageProps> = ({
    src,
    alt,
    fallback,
    className,
    onError,
    ...props
}) => {
    const [hasError, setHasError] = useState(false);

    if (hasError) {
        return fallback ? <>{fallback}</> : null;
    }

    if (!src) {
        return fallback ? <>{fallback}</> : null;
    }

    return (
        <img
            src={src}
            alt={alt}
            className={className}
            onError={(e) => {
                setHasError(true);
                if (onError) onError(e);
            }}
            {...props}
        />
    );
};
